// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../../../types/schema';

import { gql } from '@apollo/client';
export type ProfessionalTeamRoleSlide_ProfessionalTeamRoleFragment = { __typename?: 'ProfessionalTeamRole', id: string, kind: Types.ProfessionalTeamRoleKind, powerOfAttorneyKind?: Types.ProfessionalTeamRolePowerOfAttorneyKind | null, otherRoleName?: string | null, associatedClientIndividual?: { __typename?: 'ClientProfile', id: string, displayName: string } | null, associatedClientOrganization?: { __typename?: 'ClientOrganization', id: string, displayName: string } | null };

export type ProfessionalTeamSlide_ClientProfileFragment = { __typename?: 'ClientProfile', id: string, displayName: string, email?: string | null, professionalTeamRoles: { __typename?: 'ProfessionalTeamRoleConnection', edges?: Array<{ __typename?: 'ProfessionalTeamRoleEdge', node?: (
        { __typename?: 'ProfessionalTeamRole' }
        & ProfessionalTeamRoleSlide_ProfessionalTeamRoleFragment
      ) | null } | null> | null } };

export type ProfessionalTeamSlide_ClientOrganizationFragment = { __typename?: 'ClientOrganization', id: string, displayName: string, email?: string | null, professionalTeamRoles: { __typename?: 'ProfessionalTeamRoleConnection', edges?: Array<{ __typename?: 'ProfessionalTeamRoleEdge', node?: (
        { __typename?: 'ProfessionalTeamRole' }
        & ProfessionalTeamRoleSlide_ProfessionalTeamRoleFragment
      ) | null } | null> | null } };

export const Operations = {
  Fragment: {
    ProfessionalTeamRoleSlide_ProfessionalTeamRole: 'ProfessionalTeamRoleSlide_ProfessionalTeamRole' as const,
    ProfessionalTeamSlide_ClientProfile: 'ProfessionalTeamSlide_ClientProfile' as const,
    ProfessionalTeamSlide_ClientOrganization: 'ProfessionalTeamSlide_ClientOrganization' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const ProfessionalTeamRoleSlide_ProfessionalTeamRoleFragmentDoc = gql`
    fragment ProfessionalTeamRoleSlide_ProfessionalTeamRole on ProfessionalTeamRole {
  id
  kind
  powerOfAttorneyKind
  otherRoleName
  associatedClientIndividual {
    id
    displayName
  }
  associatedClientOrganization: organization {
    id
    displayName: name
  }
}
    `;
export const ProfessionalTeamSlide_ClientProfileFragmentDoc = gql`
    fragment ProfessionalTeamSlide_ClientProfile on ClientProfile {
  id
  displayName
  email
  professionalTeamRoles {
    edges {
      node {
        ...ProfessionalTeamRoleSlide_ProfessionalTeamRole
      }
    }
  }
}
    ${ProfessionalTeamRoleSlide_ProfessionalTeamRoleFragmentDoc}`;
export const ProfessionalTeamSlide_ClientOrganizationFragmentDoc = gql`
    fragment ProfessionalTeamSlide_ClientOrganization on ClientOrganization {
  id
  displayName: name
  email: pointOfContactEmail
  professionalTeamRoles {
    edges {
      node {
        ...ProfessionalTeamRoleSlide_ProfessionalTeamRole
      }
    }
  }
}
    ${ProfessionalTeamRoleSlide_ProfessionalTeamRoleFragmentDoc}`;